import { Mutation, MutationTree } from 'vuex'
import { State } from './state'
import { NumericStatWithUpdatedAt, ObjectDataWithPaginator, ObjectStatWithUpdatedAt } from './types'


export function loadingTotalStatsDeklaracje(state: State) {
    state.totalStatsDeklaracjeLoading = true;
}

export function loadedTotalStatsDeklaracje(state: State, stat: NumericStatWithUpdatedAt) {
    state.totalStatsDeklaracjeLoading = false;
    state.totalStatsDeklaracje = stat.stat;
    state.totalStatsDeklaracjeUpdatedAt = stat.updatedAt;
}

export function refreshingTotalStatsDeklaracje(state: State) {
    state.totalStatsDeklaracjeLoading = true;
}

export function loadingTotalStatsPobrania(state: State) {
    state.totalStatsPobraniaLoading = true;
}

export function loadedTotalStatsPobrania(state: State, stat: NumericStatWithUpdatedAt) {
    state.totalStatsPobraniaLoading = false;
    state.totalStatsPobrania = stat.stat;
    state.totalStatsPobraniaUpdatedAt = stat.updatedAt;
}

export function refreshingTotalStatsPobrania(state: State) {
    state.totalStatsPobraniaLoading = true;
}

export function loadingTotalStatsUruchomienia(state: State) {
    state.totalStatsUruchomieniaLoading = true;
}

export function loadedTotalStatsUruchomienia(state: State, stat: NumericStatWithUpdatedAt) {
    state.totalStatsUruchomieniaLoading = false;
    state.totalStatsUruchomienia = stat.stat;
    state.totalStatsUruchomieniaUpdatedAt = stat.updatedAt;
}

export function refreshingTotalStatsUruchomienia(state: State) {
    state.totalStatsUruchomieniaLoading = true;
}

export function loadingTotalStatsDeklaracjeLastYear(state: State) {
    state.totalStatsDeklaracjeLastYearLoading = true;
}

export function loadedTotalStatsDeklaracjeLastYear(state: State, stat: NumericStatWithUpdatedAt) {
    state.totalStatsDeklaracjeLastYearLoading = false;
    state.totalStatsDeklaracjeLastYear = stat.stat;
    state.totalStatsDeklaracjeLastYearUpdatedAt = stat.updatedAt;
}

export function refreshingTotalStatsDeklaracjeLastYear(state: State) {
    state.totalStatsDeklaracjeLastYearLoading = true;
}

export function loadingAggregatedStatsDeklaracje(state: State) {
    state.aggregatedStatsDeklaracjeLoading = true;
}

export function loadingAggregatedStatsDeklaracjeLastYear(state: State) {
    state.aggregatedStatsDeklaracjeLastYearLoading = true;
}

export function loadedAggregatedStatsDeklaracjeDataset(state: State, stat: ObjectStatWithUpdatedAt) {
    state.aggregatedStatsDeklaracjeLoading = false;
    state.aggregatedStatsDeklaracjeDataset = stat.stat;
    state.aggregatedStatsDeklaracjeUpdatedAt = stat.updatedAt;
}

export function loadedAggregatedStatsDeklaracjeLastYearDataset(state: State, stat: ObjectStatWithUpdatedAt) {
    state.aggregatedStatsDeklaracjeLastYearLoading = false;
    state.aggregatedStatsDeklaracjeLastYearDataset = stat.stat;
}

export function setAggregatedStatsDeklaracjeDatasets(state: State, datasets: object) {
    state.aggregatedStatsDeklaracjeDatasets = datasets;
}

export function loadPreviousAggregatedStatsDeklaracje(state: State, newDateTo: string) {
    state.aggregatedStatsDeklaracjeDataset = {};
    state.aggregatedStatsDeklaracjeLastYearDataset = {};
    state.aggregatedStatsDeklaracjeDatasets = {};
    state.aggregatedStatsDeklaracjeDateTo =  newDateTo;
}

export function loadNextAggregatedStatsDeklaracje(state: State, newDateTo: string) {
    state.aggregatedStatsDeklaracjeDataset = {};
    state.aggregatedStatsDeklaracjeLastYearDataset = {};
    state.aggregatedStatsDeklaracjeDatasets = {};
    state.aggregatedStatsDeklaracjeDateTo =  newDateTo;
}

export function refreshingAggregatedStatsDeklaracje(state: State) {
    state.aggregatedStatsDeklaracjeLoading = true;
    state.aggregatedStatsDeklaracjeLastYearLoading = true;
}


export function loadingAggregatedStatsUruchomienia(state: State) {
    state.aggregatedStatsUruchomieniaLoading = true;
}

export function loadingAggregatedStatsUruchomieniaLastYear(state: State) {
    state.aggregatedStatsUruchomieniaLastYearLoading = true;
}

export function loadedAggregatedStatsUruchomieniaDataset(state: State, stat: ObjectStatWithUpdatedAt) {
    state.aggregatedStatsUruchomieniaLoading = false;
    state.aggregatedStatsUruchomieniaDataset = stat.stat;
    state.aggregatedStatsUruchomieniaUpdatedAt = stat.updatedAt;
}

export function loadedAggregatedStatsUruchomieniaLastYearDataset(state: State, stat: ObjectStatWithUpdatedAt) {
    state.aggregatedStatsUruchomieniaLastYearLoading = false;
    state.aggregatedStatsUruchomieniaLastYearDataset = stat.stat;
}

export function setAggregatedStatsUruchomieniaDatasets(state: State, datasets: object) {
    state.aggregatedStatsUruchomieniaDatasets = datasets;
}

export function loadPreviousAggregatedStatsUruchomienia(state: State, newDateTo: string) {
    state.aggregatedStatsUruchomieniaDataset = {};
    state.aggregatedStatsUruchomieniaLastYearDataset = {};
    state.aggregatedStatsUruchomieniaDatasets = {};
    state.aggregatedStatsUruchomieniaDateTo =  newDateTo;
}

export function loadNextAggregatedStatsUruchomienia(state: State, newDateTo: string) {
    state.aggregatedStatsUruchomieniaDataset = {};
    state.aggregatedStatsUruchomieniaLastYearDataset = {};
    state.aggregatedStatsUruchomieniaDatasets = {};
    state.aggregatedStatsUruchomieniaDateTo =  newDateTo;
}

export function refreshingAggregatedStatsUruchomienia(state: State) {
    state.aggregatedStatsUruchomieniaLoading = true;
    state.aggregatedStatsUruchomieniaLastYearLoading = true;
}

export function loadingStatsTopOperatingSystems(state: State) {
    state.statsTopOperatingSystemsLoading = true;
}

export function loadedStatsTopOperatingSystemsDataset(state: State, stat: ObjectStatWithUpdatedAt) {
    state.statsTopOperatingSystemsLoading = false;
    state.statsTopOperatingSystemsDataset = stat.stat;
    state.statsTopOperatingSystemsUpdatedAt = stat.updatedAt;
}

export function refreshingStatsTopOperatingSystems(state: State) {
    state.statsTopOperatingSystemsLoading = true;
}

export function setPageStatsTopBrowsers(state: State, page: number) {
    state.statsTopBrowsersPage = page;
}

export function loadingStatsTopBrowsers(state: State) {
    state.statsTopBrowsersLoading = true;
}

export function loadedStatsTopBrowsers(state: State, data: ObjectDataWithPaginator) {
    state.statsTopBrowsersLoading = false;
    state.statsTopBrowsersData = {data: data.data};
    state.statsTopBrowsersCurrentPage = data.currentPage;
    state.statsTopBrowsersTotal = data.total;
}

export function loadingStatsTopBrowsersAggregated(state: State) {
    state.statsTopBrowsersAggregatedLoading = true;
}

export function loadedStatsTopBrowsersAggregated(state: State, data: object) {
    state.statsTopBrowsersAggregatedLoading = false;
    state.statsTopBrowsersAggregatedData = data;
}

export function setPageStatsTopIP(state: State, page: number) {
    state.statsTopIPPage = page;
}

export function loadingStatsTopIP(state: State) {
    state.statsTopIPLoading = true;
}

export function loadedStatsTopIP(state: State, data: ObjectDataWithPaginator) {
    state.statsTopIPLoading = false;
    state.statsTopIPData = {data: data.data};
    state.statsTopIPCurrentPage = data.currentPage;
    state.statsTopIPTotal = data.total;
}

export function setPageStatsTopPobraniaReferers(state: State, page: number) {
    state.statsTopPobraniaReferersPage = page;
}

export function loadingStatsTopPobraniaReferers(state: State) {
    state.statsTopPobraniaReferersLoading = true;
}

export function loadedStatsTopPobraniaReferers(state: State, data: ObjectDataWithPaginator) {
    state.statsTopPobraniaReferersLoading = false;
    state.statsTopPobraniaReferersData = {data: data.data};
    state.statsTopPobraniaReferersCurrentPage = data.currentPage;
    state.statsTopPobraniaReferersTotal = data.total;
}

export default <MutationTree<State>> {
    loadingTotalStatsDeklaracje,
    loadedTotalStatsDeklaracje,
    refreshingTotalStatsDeklaracje,
    loadingTotalStatsPobrania,
    loadedTotalStatsPobrania,
    refreshingTotalStatsPobrania,
    loadingTotalStatsUruchomienia,
    loadedTotalStatsUruchomienia,
    refreshingTotalStatsUruchomienia,
    loadingTotalStatsDeklaracjeLastYear,
    loadedTotalStatsDeklaracjeLastYear,
    refreshingTotalStatsDeklaracjeLastYear,
    loadingAggregatedStatsDeklaracje,
    loadingAggregatedStatsDeklaracjeLastYear,
    loadedAggregatedStatsDeklaracjeDataset,
    loadedAggregatedStatsDeklaracjeLastYearDataset,
    setAggregatedStatsDeklaracjeDatasets,
    loadPreviousAggregatedStatsDeklaracje,
    loadNextAggregatedStatsDeklaracje,
    refreshingAggregatedStatsDeklaracje,
    loadingAggregatedStatsUruchomienia,
    loadingAggregatedStatsUruchomieniaLastYear,
    loadedAggregatedStatsUruchomieniaDataset,
    loadedAggregatedStatsUruchomieniaLastYearDataset,
    setAggregatedStatsUruchomieniaDatasets,
    loadPreviousAggregatedStatsUruchomienia,
    loadNextAggregatedStatsUruchomienia,
    refreshingAggregatedStatsUruchomienia,
    loadingStatsTopOperatingSystems,
    loadedStatsTopOperatingSystemsDataset,
    refreshingStatsTopOperatingSystems,
    setPageStatsTopBrowsers,
    loadingStatsTopBrowsers,
    loadedStatsTopBrowsers,
    loadingStatsTopBrowsersAggregated,
    loadedStatsTopBrowsersAggregated,
    setPageStatsTopIP,
    loadingStatsTopIP,
    loadedStatsTopIP,
    setPageStatsTopPobraniaReferers,
    loadingStatsTopPobraniaReferers,
    loadedStatsTopPobraniaReferers
}
